import { render, staticRenderFns } from "./DetectAlisonDesktop.vue?vue&type=template&id=108aef4d"
import script from "./DetectAlisonDesktop.vue?vue&type=script&lang=js"
export * from "./DetectAlisonDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports